import React from "react"
import { Link } from "gatsby"
import SkillFactoryImg from "../../../images/skill-factory-img.svg"
import SkillFactoryImg1 from "../../../images/skill-factory-1.svg"
import SkillFactoryImg2 from "../../../images/skill-factory-2.svg"

const Hero = () => {
  return (
    <section className="bg-primary text-white container mx-auto px-6 pt-12">
      <div className="flex flex-col-reverse md:flex-row items-center">
        <div className="flex-1 md:w-1/2 md:pr-4">
          <h1 className="text-5xl lg:text-7xl font-light mb-8 leading-tight">
            <span className="text-secondary font-bold block">Skill</span>
            Factory
          </h1>
          <h3 className="text-2xl pb-8 text-secondary">
            We absolutely <span className="text-white">love training.</span>
            <br />
            It is a complete success to train professionals and insert them into
            the IT industry.
          </h3>
          <Link
            to="/contact"
            className="lg:mr-5 lg:mx-0 my-8 border-white border-solid border-2 hover:text-white hover:bg-secondary hover:text-variant btn"
          >
            Contact us
          </Link>
        </div>
        <div className="flex-1 my-8 md:my-0 w-full md:w-1/2">
          <img
            src={SkillFactoryImg}
            alt="Skill Factory"
            className="mx-auto"
            width="500"
          />
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-center py-20">
        <div className="w-full md:w-1/2 pb-8">
          <img
            src={SkillFactoryImg1}
            alt="What is it?"
            className="mx-auto"
            width="300"
          />
        </div>
        <div className="w-full md:w-1/2 md:px-8">
          <h4 className="text-5xl pb-8 font-normal leading-tight">
            <span className="text-secondary block font-bold">What </span> is it?
          </h4>
          <p className="pb-8 text-xl">
            This is our teaching model, an intensive 3-month training program,
            where we teach how to master the most demanded languages and
            technologies. Once the workshop finishes, you will have the
            possibility to be part of our Team.
          </p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row-reverse items-center pb-8">
        <div className="w-full md:w-1/2 pb-8">
          <img
            src={SkillFactoryImg2}
            alt="Staff Augmentation"
            className="mx-auto"
            width="300"
          />
        </div>
        <div className="w-full md:w-1/2 md:px-8">
          <h4 className="text-5xl pb-8 font-normal leading-tight">
            <span className="text-secondary block font-bold">How </span> it
            works?
          </h4>
          <p className="pb-8 text-xl">
            If you are passionate about programming and you are looking for the
            best environment to grow as a professional, contact us and join the
            Skill Factory Team!
          </p>
          <Link
            to="/contact"
            className="lg:mr-5 lg:mx-0 my-8 border-white border-solid border-2 hover:text-white hover:bg-secondary hover:text-variant btn"
          >
            Contact us
          </Link>
        </div>
      </div>
    </section>
  )
}
export default Hero
